import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import BillPrint from '../salereturn/Bill';
import PrintIcon from '@mui/icons-material/Print';
import Info from '@mui/icons-material/Info';
import ReactDOM from 'react-dom';


function SaleReturnIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory(); // Access the navigation history
    const [isFocused, setIsFocused] = useState('');
    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const hasDeleteMasterPermission = permissions.includes('Delete Transaction');
    const branchId=0;
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const fetchtableData = async () => {
        fetchData('SaleReturnApi', `/${companyId}/${branchId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                    // setFilteredData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Return Details:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            });
    };

    const handleDelete = async () => {
        deleteData('SaleReturnApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('SaleReturnApi', `${itemId}`, token)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    const handlePrint = async (saleid) => {
        try {

            const response = await fetchData('SaleReturnApi', `/SalePrint/${saleid}/${branchId}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();
            // iframe.contentWindow.print();
            setTimeout(() => {
                iframe.contentWindow.print();
            }, 1000);

        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    return (
        <div className="w-full  mx-auto" style={{ width: '95%' ,marginTop:'10px'}}>
            <div className='w-full mb-2 flex'>
                <h5 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Sale Return</h5>
                <div style={{ marginTop: '10px', marginLeft: '12px' }}>

                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '300px' : '200px',
                            height: '40px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            marginTop: '10px',
                            marginLeft: '12px',

                        }}
                    />

                    {hasCreateMasterPermission && (
                        <Button
                            variant="contained"
                            color="primary"
                            component={Link}
                            to="/SaleReturnCreate"
                            className="linkcolor"
                            style={{ marginLeft: '8px' }}
                        >
                            CREATE NEW
                        </Button>
                    )}
                </div>
                </div>

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: 'teal' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5',  fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '7%' }}>Bill Date</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5',  fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '10%' }}>Bill Number</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5',  fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '15%' }}>Customer Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5',  fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '13%' }}>Contact Number</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5',  fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5',  fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>CSGT</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5',  fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>SGST</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5',  fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>IGST</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5',  fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>Total</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5',  fontSize: '16px', padding: '7px', color: 'whitesmoke', textAlign: 'center' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#B1CAE6' }}>
                            {filteredData.map(item => (
                                <TableRow key={item.id} className={item.IsActive ? '' : 'inactiveRow'}>
                                    <TableCell sx={{ height: '30px', padding: '5px', width: '7%' }}>{formatDate(item.BillDate)}</TableCell>
                                    <TableCell sx={{ height: '30px', padding: '5px', width: '10%' }}>{item.BillPrefix}/SR/{item.BillNumber}/{item.FinYear}</TableCell>
                                    <TableCell sx={{ height: '30px', padding: '5px', width: '15%' }}>{item.CustomerName}</TableCell>
                                    <TableCell sx={{ height: '30px', padding: '5px', width: '13%' }}>{item.ContactNumber}</TableCell>
                                    <TableCell sx={{ height: '30px', padding: '5px', width: '10%', textAlign: 'center' }}>{item.TaxableAmount}</TableCell>
                                    <TableCell sx={{ height: '30px', padding: '5px', width: '7%', textAlign: 'center' }}>{item.CGSTAmount}</TableCell>
                                    <TableCell sx={{ height: '30px', padding: '5px', width: '7%', textAlign: 'center' }}>{item.SGSTAmount}</TableCell>
                                    <TableCell sx={{ height: '30px', padding: '5px', width: '7%', textAlign: 'center' }}>{item.IGSTAmount}</TableCell>
                                    <TableCell sx={{ height: '30px', padding: '5px', width: '7%', textAlign: 'center' }}>{item.GrandTotal}</TableCell>
                                    <TableCell sx={{ height: '30px', padding: '5px', width: '15%', textAlign: 'right' }}>

                                        <IconButton component={Link} to={`/SaleReturnDetails/${item.Id}`} color="secondary">
                                            <Info />
                                        </IconButton>

                                        <IconButton onClick={() => handlePrint(item.Id)} color="warning">
                                            <PrintIcon />
                                        </IconButton>


                                        {hasEditMasterPermission && item.IsActive && (
                                            <IconButton component={Link} to={`/SaleReturnEdit/${item.Id}`} color="primary">
                                                <EditIcon />
                                            </IconButton>
                                        )}

                                        {hasDeleteMasterPermission && (
                                            <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))} color="success">
                                                {item.IsActive ? <DeleteIcon /> : <ActivateIcon />}
                                            </IconButton>
                                        )}

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>

                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default SaleReturnIndex;

